(ns hai.library.prompts.routes
  "Prompt section

  Allow listing/creating/updating/deleting of LLM prompts."
  (:require
   hai.library.prompts.api
   [hai.library.prompts.create :as create]
   [hai.library.prompts.edit :as edit]
   [hai.library.prompts.table :as table]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [>e]]
   [hai.web-app.routing :as routing]))

(defn routes
  []
  [["/assistant/prompts"
    {::routing/window-title "Templates"
     ;; TODO this doesn't work as it duplicates the crumb for the table page and so we have the
     ;; crumb in each sub route
     :icon icons/outlined-library_books}
    [""
     {:name        :ai-prompts/table
      :label       "Templates"
      :breadcrumbs ["Prompt library"]
      :view        table/page}]
    [""
     {:breadcrumbs [:ai-prompts/table]}
     ["/create"
      {:name :ai-prompt/create
       ::routing/window-title "New Template"
       :label/short "New Template"
       :label "Create Text Template"
       :view create/page}]
     ["/{ai-prompt/uuid}/edit"
      {:name :ai-prompts/edit
       :view edit/page
       :controllers [{:parameters {:path [:ai-prompt/uuid]}
                      :start (fn [{prompt :path}]
                               (>e [:entity/resolve prompt]))}]}]
     ["/{ai-prompt/uuid}/edit/sharing"
      {:name :ai-prompts.edit/sharing
       :view edit/sharing
       :controllers [{:parameters {:path [:ai-prompt/uuid]}
                      :start (fn [{prompt :path}]
                               (>e [:entity/resolve prompt]))}]}]]]])
